
export default [
    {
        name: 'light',
        value: 'light'
    },
    {
        name: 'dark',
        value: 'dark'
    },
    {
        name: 'stellar-light',
        value: 'stellar-light'
    }
]